import styled from 'styled-components'
import { colors, device } from 'Styled/variables'

export const StepWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  overflow-x: scroll;

  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  @media ${device.mobileMax} {
    margin-right: 34px;
    padding: 0;
    width: fit-content;
  }
`

export const OverflowContainer = styled.div`
  @media (max-width: 576px) {
    position: relative;
    margin-right: 26px;
    width: 100vw;
    overflow-x: scroll;

    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`
